import React from "react";
import classNames from "classnames";

import { Button } from "../button";

import "./floating-bar-button.css";

export function FloatingBarButton({
	className,
	checked,
	outlined,
	...props
}: React.ComponentProps<typeof Button> & {
	checked?: boolean;
	outlined?: boolean;
}) {
	return (
		<Button
			variant={outlined ? "default" : "flat"}
			checked={checked}
			className={classNames("floating-bar-button", className)}
			{...props}
		/>
	);
}
